// crearGasto.usecase.js

import {
guardarGasto
} from "../infrastructure/supabase/gastos.repository.js";

import { ahora } from "../../../utils/fechas.js";

export async function crearGastoUseCase(data) {
  if (!data) {
    throw new Error("[crearGasto.usecase] No se recibieron datos del gasto");
  }

  const {
    id_usuario,
    item_valor,
    item_cantidad = 1,
    metodo_pago,
    id_categoria,
    proveedor,
    detalle,
  } = data;

  // 1️⃣ Validaciones
  if (!id_usuario) throw new Error("Usuario requerido");

  if (!item_valor || Number(item_valor) <= 0) {
    throw new Error("Valor unitario inválido");
  }

  if (!id_categoria) throw new Error("Categoría requerida");

  if (!metodo_pago) throw new Error("Método de pago requerido");

  
  // 2️⃣ Normalización
  const gastoNormalizado = {
    id_usuario,
    item_valor: Number(item_valor),
    item_cantidad: Number(item_cantidad) || 1,
    metodo_pago,
    id_categoria,
    proveedor: proveedor?.trim() || "Desconocido",
    detalle: detalle?.trim() || "Ninguno",
    estado: "activo",
    fecha_creacion: ahora(),
    update_at: ahora(),
  };

  console.log("GASTO NORMALIZADO:", gastoNormalizado);
  // 3️⃣ Persistencia (el repo ya maneja errores)
  const dataInsertada = await guardarGasto(gastoNormalizado);

  return dataInsertada;
}
